import useAxios from '@/hooks/useAxios'

const { get, post } = useAxios()

export const doLoginV2 = (params?: any) => post('/login/doLogin', params)

export const doRegister = (params?: any) => post('/user/doRegister', params)

export const getVerifyCode = (params?: any) => post('/user/getVerifyCode', params)

export const resetPassword = (params?: any) => post('/user/resetPassword', params)

export const getVerifyCodeByPhone = (params?: any) => post('/user/send_phone_code', params)

export const doRegisterEnterprise = (params?: any) => post('/user/doRegisterEnterprise', params)
